/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state, actions } = store( 'bv-space', {
	state: {
		get temaSlug() {
			const context = getContext();
			return context.item.slug;
		},
		get isTemaChecked() {
			const context = getContext();
			return state.activeTema === context.item.slug;
		},
		get activeTerms() {
			// Get the current maalgruppe (empty string if not set)
			const currentMaalgruppe = state.activeMalgruppe || '';
			// Access nested structure from state: post_type -> maalgruppe -> terms
			const activeTerms = state.allTerms?.[state.activeButton]?.[currentMaalgruppe] || [];
			const hasTema = activeTerms.some(t => t.slug === state.activeTema);
			if (!hasTema) {
				state.activeTema = false;
			}
			return activeTerms;
		}
	},
	actions: {
		setActiveTema() {
			const context = getContext();
			if (state.activeTema === context.item.slug) {
				// If it's already active, deselect it
				state.activeTema = false;
			} else {
				state.activeTema = context.item.slug;
			}
			actions.updateURL();
		},
		refreshActiveTerms() {
			// Force a refresh of activeTerms by accessing it
			// This can be called when activeMalgruppe changes
			const terms = state.activeTerms;
			return terms;
		}
	},
	callbacks: {

	},
} );
